
export const KEY_TOKEN = 'token'

// export const BASE_URL = 'http://192.168.100.110:3000';
export const BASE_URL = 'https://digilog.testika.ir';


export const isInProductionMode = process.env.NODE_ENV === 'production'

export const preUrl = isInProductionMode ? 'https://' : 'http://';

export const supportPhone = "+989350805855"



// Detect current host (e.g., test.digilog.pro or shop.digigold.pro)
const currentHost = typeof window !== 'undefined' ? window.location.host : 'localhost:3000';

// Extract root domain
function getRootDomain(host) {
    const parts = host.split('.');

    // handle localhost or IP cases
    if (host.includes('localhost') || /^[0-9.]+$/.test(host)) {
        return 'localhost:3000';
    }

    // handle 2-level domains like "digilog.pro" or "digigold.pro"
    if (parts.length >= 2) {
        return parts.slice(-2).join('.');
    }

    return host;
}

// This will give you 'digilog.pro', 'digigold.pro', or 'localhost:3000'
export const projectUrl = getRootDomain(currentHost);

console.log('Detected projectUrl:', projectUrl);